import { View } from 'react-native'

import { icoMoonConfig } from '@raiadrogasil/pulso-icons'

import Svg, { Path } from '@rd-core-svg/svg'
import IcoMoon from 'react-icomoon'

import type {
  IconNameBullet,
  IconNameMulticolor,
  TIconDualColorsProps,
  TIconProps,
} from './types'

import { IconDualColor } from './components/dual-color'
import { useIconProps } from './hooks/use-icon-props'

const Icon = ({
  size = 'medium',
  color,
  symbol = 'rdicon-default',
  testID,
}: TIconProps) => {
  const { size: iconSize, color: iconColor } = useIconProps({ size, color })

  const iconSymbol = symbol.replace('rdicon-', '')

  const iconProps = {
    size: iconSize,
    color: iconColor,
    icon: iconSymbol,
  }

  return (
    <View testID={testID}>
      <IcoMoon
        {...iconProps}
        SvgComponent={Svg}
        PathComponent={Path}
        iconSet={icoMoonConfig}
        native
      />
    </View>
  )
}

Icon.Dual = IconDualColor

export {
  Icon,
  type TIconProps,
  type TIconDualColorsProps,
  type IconNameBullet,
  type IconNameMulticolor,
}
